import axios from '../utils/axios';

export default function fetchRecruitersDetails(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/recruiters-details', { params })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
